import Tooltip from "@/components/common/Tooltip";
import { cx } from "@/utils/ui/uiHelpers";

const Label: React.FC<LabelProps> = ({
  name,
  tooltipText = "",
  cssClasses = "text-xs poppins text-black dark:text-gray-200 mb-2",
  for: htmlFor,
}) => {
  return (
    <div className="pb-2">
      <label className={cx(cssClasses)} htmlFor={htmlFor}>
        <span>{name}</span>
        {tooltipText && (
          <Tooltip
            content={tooltipText}
            className={cx("float-right")}
            iconClassName="ml-1"
          />
        )}
      </label>
    </div>
  );
};

type LabelProps = {
  name: string;
  tooltipText?: string;
  cssClasses?: string;
  for?: string;
};

export default Label;
